import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-dark text-white py-5">
      <Container>
        <Row className="g-4">
          <Col lg={4} md={6} className="text-center text-md-start">
            <h5 className="fw-bold mb-3">Jesus Le Bon Berger Church</h5>
            <p className="mb-2">
              <i className="bi bi-geo-alt-fill me-2"></i>
              221 N Dooley Street<br />
              Grapevine, TX 76051
            </p>
          </Col>
          <Col lg={4} md={6} className="text-center">
            <h6 className="fw-bold mb-3">Contact Us</h6>
            <p className="mb-2">
              <i className="bi bi-envelope-fill me-2"></i>
              <a href="mailto:info@jesuslebonberger.org" className="text-white text-decoration-none">
                info@jesuslebonberger.org
              </a>
            </p>
          </Col>
          <Col lg={4} className="text-center text-lg-end">
            <h6 className="fw-bold mb-3">Follow Us</h6>
            <div className="mb-3">
              <a href="#" className="text-white me-3 fs-4"><i className="bi bi-facebook"></i></a>
              <a href="#" className="text-white me-3 fs-4"><i className="bi bi-instagram"></i></a>
              <a href="#" className="text-white fs-4"><i className="bi bi-youtube"></i></a>
            </div>
          </Col>
        </Row>
        <hr className="my-4 border-secondary" />
        <Row>
          <Col className="text-center">
            <p className="small mb-0 text-muted">
              © {currentYear} JLBB Ministries. All rights reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;